<!-- 测试方式 -->
<template>
  <BaseFormItem2
    class="test"
    :label="fields.label"
    :labelTips="fields.labelTips"
  >
    <div :class="{ 'is-loading': loading }">
      <BaseRadioGroup2 v-model="val" @change="handleEmit">
        <el-radio-button
          v-for="item in options"
          :key="item.value"
          :label="item.value"
          :disabled="item.disabled"
        >{{ item.label }}</el-radio-button>
      </BaseRadioGroup2>
      <i v-if="loading" class="el-icon-loading test__loading"></i>
    </div>
  </BaseFormItem2>
</template>

<script>
import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: String,
      default: '样品免费测试'
    },
    // 测试方式展示(前端字段)
    view_test: {
      type: String,
      default: ''
    },
    testOptions: {
      type: Array,
      default: () => ([])
    },
    // 计价loading
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: this.value
    }
  },
  computed: {
    fields() {
      return getFR4Fields('test')
    },
    options() {
      const { fields, testOptions } = this
      if (testOptions && testOptions.length > 0) {
        return testOptions.map(({ real, word }) => ({ label: word, value: real }))
      }
      
      return fields.options
    }
  },
  watch: {
    value(newVal) {
      if (this.val != newVal && this.val == '抽测') { 
        this.changeVal(newVal)
      }
      this.val = newVal
      this.handleEmit()
    },
    testOptions(testOptions) {
      this.testOptions = testOptions
    }
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)

      const item = this.options.find(item => item.value == val)
      if (item) {
        this.$emit('update:view_test', item.label)
      }
    },
    changeVal(val) {
      this.$topWarning.mergeFields(this.fields.label)
      this.val = val
      this.handleEmit()
    }
  }
}
</script>

<style lang="scss" scoped>
.test {
  .is-loading {
    position: relative;
    display: flex;
    align-items: center;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 99;
      background: rgba(255, 255, 255, 0.45);
    }
    .test__loading {
      margin-left: 10px;
      font-size: 16px;
    }
  }
}
</style>